import React, { useEffect, useState } from "react";
import { Link } from 'react-scroll';
import sherwenlogo from '../../Assets/sherwenlogo.png';
import user from '../../Assets/user.png';
import Menu from '../../Assets/menu.png';
import Close from '../../Assets/close.png';
import './Navbar.css';
import 'transition-style';



const Navbar = () => {


  const [isSticky] = useState(true);
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const [prevScrollY, setPrevScrollY] = useState(0);
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setIsScrollingUp(currentScrollY > prevScrollY);
      setPrevScrollY(currentScrollY);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [prevScrollY]);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleClick = () => {
    window.location.reload();
  };


  return (
    <div className={`navbar ${isSticky ? 'sticky' : ''} ${isScrollingUp ? 'hidden' : ''}`}>
      <div className="navbarShowHide">
        <div className="n-left" onClick={handleClick}>
          <img src={sherwenlogo} alt="Sherwen's Logo"  />
        </div>
        <div className="n-right">
          <div className="n-list">
            <Link activeClass='active' to='intro' spy={true} smooth={true} offset={-100} duration={500} className='desktopMenuListItem'>Home</Link>
            <Link activeClass='active' to='timeline' spy={true} smooth={true} offset={0} duration={500} className='desktopMenuListItem'>Education</Link>
            <Link activeClass='active' to='skills' spy={true} smooth={true} offset={0} duration={500} className='desktopMenuListItem'>Skills</Link>
            <Link activeClass='active' to='works' spy={true} smooth={true} offset={0} duration={500} className='desktopMenuListItem'>Projects</Link>
          </div>
          <Link activeClass='active' to='contact' spy={true} smooth={true} offset={0} duration={500} className='desktopMenuListItemBtn'>
            <button className="desktopMenuBtn">
              <img src={user} alt='Contact' className='desktopMenuImg' />Contact Me</button>
          </Link>

         
        </div>
        
        <div className="mobileMenu" >
            {!showMenu ? (
              <img src={Menu} alt="Open Menu" onClick={toggleMenu} transition-style="in:custom:circle-swoop"/>
            ) : (
              <img src={Close} alt="Close Menu" onClick={toggleMenu} />
            )}
            <div className="navMenu" style={{ display: showMenu ? 'block'  : 'none' }} transition-style="in:custom:circle-swoop">
             <div><Link activeClass='active1' to='intro' spy={true} smooth={true} offset={-100} duration={500} className='listItem' onClick={toggleMenu}>Home</Link></div> 
             <div><Link activeClass='active1' to='timeline' spy={true} smooth={true} offset={0} duration={500} className='listItem' onClick={toggleMenu}>Education</Link></div> 
             <div><Link activeClass='active1' to='skills' spy={true} smooth={true} offset={0} duration={500} className='listItem' onClick={toggleMenu}>Skills</Link></div> 
             <div><Link activeClass='active1' to='works' spy={true} smooth={true} offset={0} duration={500} className='listItem' onClick={toggleMenu}>Projects</Link></div> 
             <div><Link activeClass='active1' to='contact' spy={true} smooth={true} offset={0} duration={500} className='listItem' onClick={toggleMenu}>Contact Me</Link></div> 
            </div>
          </div>
      </div>
      
    </div>
  );
}

export default Navbar;
